import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=1f7ed788&scoped=true&lang=css"

import exportComponent from "/Users/wangjian/study/nodejs/vue/jsontool/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.10_vue@3.5.10_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f7ed788"]])

export default __exports__